/**
 * Saneamiento del cadJson recién parseado del DXF.
 *
 * Filtro: **Polilíneas con vertex en (0,0)** — descartadas. En diseños DXF
 * reales el origen del mundo es un lugar arbitrario donde raramente pasan
 * polilíneas legítimas. Los XREF/INSERTs de AutoCAD suelen dejar artefactos
 * en la capa "0" con un vertex en (0,0) y otro en el punto de inserción —
 * invisibles en AutoCAD pero presentes en el cadJson, y al renderizarlos
 * crean "líneas hacia el origen" que ensucian la vista.
 *
 * NOTA: antes existía un segundo filtro ("entities no-polilínea fuera del
 * cluster") que descartaba INSERTs/labels lejanos del núcleo. Se retiró porque
 * trabajaba sobre coordenadas CRUDAS (pre-OCS) y borraba inserts que en
 * realidad caen dentro del parque una vez el render aplica la transformación
 * OCS→WCS (ver fix en DxfScene.GetInsertionTransform). El encuadre correcto lo
 * garantiza ahora el motor, no este recorte.
 *
 * NO TOCA:
 *   - Polilíneas dentro de blocks (cadJson.blocks) — sus coords son relativas
 *     al origen del block, no al mundo.
 */

const POLYLINE_TYPES = new Set(['LINE', 'LWPOLYLINE', 'POLYLINE'])

function hasVertexAtOrigin(entity) {
  const verts = entity?.vertices
  if (!verts) return false
  for (const v of verts) {
    if (v?.x === 0 && v?.y === 0) return true
  }
  return false
}

/**
 * @param {Object} cadJson - resultado del parser DXF
 * @returns {{ cadJson: Object, removed: number }}
 */
export function sanitizeCadJson(cadJson) {
  if (!cadJson?.entities) {
    return { cadJson, removed: 0 }
  }

  const isArr = Array.isArray(cadJson.entities)
  const list  = isArr ? cadJson.entities : Object.values(cadJson.entities)

  let removed = 0
  const kept = []
  for (const e of list) {
    if (POLYLINE_TYPES.has(e?.type) && hasVertexAtOrigin(e)) {
      removed += 1
      continue
    }
    kept.push(e)
  }

  if (removed === 0) {
    return { cadJson, removed: 0 }
  }

  const nextEntities = isArr
    ? kept
    : Object.fromEntries(kept.map(e => [e.handle ?? e.id, e]))

  return { cadJson: { ...cadJson, entities: nextEntities }, removed }
}
